import { jsonFetch } from "@/lib/helpers";
import { Pax } from "@/models";
import { GET_PAX_BUCKET_BETWEEN_RANGE_BY_ROOM_ID } from "./api-url.constants";
import { PaxDTO } from "./dtos";
import { mapPaxDtoToPax } from "./mappers";

interface GetPaxBucketsBetweenRangeByRoomIdParams {
  roomId: string;
  bucketCount: number;
  from: number;
  to: number;
}

export const getPaxBucketsBetweenRangeByRoomId = async ({
  roomId,
  from,
  to,
  bucketCount,
}: GetPaxBucketsBetweenRangeByRoomIdParams): Promise<Pax[]> => {
  const paxDTOs = await jsonFetch<{ data: PaxDTO[] }>(
    `${GET_PAX_BUCKET_BETWEEN_RANGE_BY_ROOM_ID}/${encodeURIComponent(roomId)}?from=${from}&to=${to}&bucketCount=${bucketCount}`
  );
  return paxDTOs.data.map(mapPaxDtoToPax).sort((a, b) => a.endDate - b.endDate);
};
